import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from "react-intl";

const GeniallyIframeView = () => {
    const navigate = useNavigate();

    return (
        <section className="gen-single-movie" style={{ padding: 0, backgroundColor: '#eee6db' }}>
            <div className="container-fluid" style={{ padding: 0 }}>
                <div className="row" style={{ margin: 0, padding: '15px' }}>
                    <div className="col-12">
                        <button 
                            onClick={() => navigate(-1)} 
                            className="gen-button small"
                            style={{ border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                        >
                            <i aria-hidden="true" className="ion ion-arrow-return-left"></i>
                            <span className="text">
                                <FormattedMessage id="buttonGoBack" defaultMessage="Regresar" />
                            </span>
                        </button>
                    </div>
                </div>
                <div className="row no-gutters" style={{ margin: 0 }}>
                    <div className="col-lg-12" style={{ 
                        height: 'calc(100vh - 70px)', 
                        minHeight: '600px', 
                        padding: 0, 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        backgroundColor: '#eee6db'
                    }}>
                        <iframe 
                            src="https://view.genially.com/6a39d9c653f8315e37ae01c8" 
                            style={{
                                width: '100%', 
                                height: 'auto', 
                                maxWidth: 'calc(max(100vh - 70px, 600px) * 16 / 9)',
                                aspectRatio: '16/9',
                                border: 'none', 
                                backgroundColor: '#eee6db'
                            }} 
                            allowFullScreen="allowfullscreen" 
                            allow="fullscreen"
                            title="Presentación Interactiva"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GeniallyIframeView;
